/**
 * Loading Spinner — Apex Design System.
 *
 * Per §14.1: spinners are only for actions where result structure is
 * unknown. For content with known structure, use skeleton screens.
 */

import { clsx } from "clsx";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeStyles = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-12 w-12",
};

function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  return (
    <div
      className={clsx("flex items-center justify-center", className)}
      aria-busy="true"
    >
      <svg
        className={clsx(
          "animate-spin text-[var(--color-interactive-primary)]",
          sizeStyles[size],
        )}
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
    </div>
  );
}

export default LoadingSpinner;
